var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inter"},[_c('div',{staticClass:"intercon"},[_c('img',{staticClass:"interani",attrs:{"src":_vm.mode[0]}})])])}
var staticRenderFns = []

export { render, staticRenderFns }